module.exports = __webpack_public_path__ + "static/media/image.c0ff73d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/Corona/image.jpg
// module id = 437
// module chunks = 0